export default {
  content: {
    display: 'flex',
    padding: [10, 16],
  },
};
